import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/PrintImports';
import { Exam } from "models/ExamModel";
import { User } from 'models/UserModel';
import { Doctor } from 'models/DoctorModel';
import { Client } from 'models/ClientModel';
import { PrescriptionData, MedicationData, CommonDataColumn } from 'models/BaseModel';
import { mapMedication, mapRxData } from 'helpers/forms/ExamHelper';

const ExamPrint: React.FC = () => {
  const width = { product: 42, price: 12, qty: 10, discount: 12, gst: 12, Amount: 12 }
  const width2 = { date: 16, receivedfrom: 30, mop: 18, receivedby: 20, amount: 16 }
  const [formId, formName] = [Code.Form.Id.EXAM, Code.Form.Name.EXAM];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [formData, setFormData] = useState<Exam>({});
  const [clientData, setClientData] = useState<Client | null>(null);
  const [doctorData, setDoctorData] = useState<Doctor | null>(null);
  const [userData, setUserData] = useState<User | null>(null);
  const [examData, setExamData] = useState<CommonDataColumn | null>(null);
  const [prescription1, setPrescription1] = useState<PrescriptionData | null>(null);
  const [prescription2, setPrescription2] = useState<PrescriptionData | null>(null);
  const [prescription3, setPrescription3] = useState<MedicationData | null>(null);
  const [prescription4, setPrescription4] = useState<PrescriptionData | null>(null);
  const [prescription5, setPrescription5] = useState<PrescriptionData | null>(null);
  const [prescription6, setPrescription6] = useState<PrescriptionData | null>(null);
  const [tableData1, setTableData1] = useState<boolean>(true);
  const [tableData2, setTableData2] = useState<boolean>(false);
  const [tableData3, setTableData3] = useState<boolean>(false);
  const [tableData4, setTableData4] = useState<boolean>(false);
  const [tableData5, setTableData5] = useState<boolean>(false);
  const [tableData6, setTableData6] = useState<boolean>(false);
  const [expiryDate, setExpiryDate] = useState<Date>(new Date());
  const [fieldDispenser, setFieldDispenser] = useState<boolean>(false);
  const [fieldClientId, setFieldClientId] = useState<boolean>(true);
  const [fieldAHC, setFieldAHC] = useState<boolean>(false);
  const [fieldDOB, setFieldDOB] = useState<boolean>(true);
  const [fieldPhone, setFieldPhone] = useState<boolean>(true);
  const [fieldAddress, setFieldAddress] = useState<boolean>(true);

  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('data');

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    API.Data.GetByKeyId<Exam>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setFormData((prevData) => ({
        ...prevData,
        ...formData,
      }));

      const fieldName = `${Name.Exam.Data}${dataId}`;
      const tempExamData = (data as any)[fieldName];

      setExamData(await Files.List.extractCommonData(tempExamData));
      setClientData(await API.Data.GetClientCity(data.client_id));
      setDoctorData(await API.Data.GetDoctor(data.doctor_id));
      setUserData(await API.Data.GetUser(data.user_id));
    }})
    setLoading(false);
  }, []); 

  useEffect(() => { MapPrescription1(true);  }, [examData]); 

  useEffect(() => { 
    if (clientData && formData) {
      let addYears = 0;
      let ageNumber = 2;
      const examType = formData.type_id;
      if (examType && examType > 0) {
        // if (examType == 10 || examType == 11 || examType == 12) {
        //   addYears = 1;
        // } else { 
          
        // }
        ageNumber = Utility.Format.AgeYear2(clientData.client_dob);
        
        //console.log('ageNumber---->',ageNumber);
        
        if (ageNumber >= 19 && ageNumber <= 65) {
          addYears = 2;
        } else {
          addYears = 1;
        }
        const newDate = DateUtility.AddYears(formData.exam_date, addYears);
        if (newDate) setExpiryDate(newDate);
      }
    }
  }, [clientData]); 

  class DateUtility {
    static AddYears(date: Date | undefined, years: number): Date | null {
      if (!date) return null;
      
      const newDate = new Date(date);
      newDate.setFullYear(newDate.getFullYear() + years);
      return newDate;
    }
  }

  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>, rxId: number) => {
    if(rxId===Code.Exam.Map.FINALRX) MapPrescription1(e.target.checked);
    else if(rxId===Code.Exam.Map.FINALRX2) MapPrescription2(e.target.checked); 
    else if(rxId===Code.Exam.Map.MEDICATION) MapPrescription3(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLTRAIL) MapPrescription4(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLTRAIL2) MapPrescription5(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLFINAL) MapPrescription6(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_AHC) setFieldAHC(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_DOB) setFieldDOB(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_PHONE) setFieldPhone(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_ADDRESS) setFieldAddress(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_CLIENT_ID) setFieldClientId(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_DISPENSER) setFieldDispenser(e.target.checked); 
  };

  const MapPrescription1 = (checked: boolean) => {
      setTableData1(checked);
      if (checked) {
        const finalRx = mapRxData(examData, Number(Code.Exam.Map.FINALRX));
        setPrescription1(finalRx);
      } else setPrescription1({}); 
  };

  const MapPrescription2 = (checked: boolean) => {
      setTableData2(checked);
      if (checked) {
        const finalRx2 = mapRxData(examData, Number(Code.Exam.Map.FINALRX2));
        setPrescription2(finalRx2);
      } else setPrescription2({});
  };

  const MapPrescription3 = (checked: boolean) => {
      setTableData3(checked);
      if (checked) {
        const Medication = mapMedication(examData);
        setPrescription3(Medication);
      } else setPrescription3({});
  };

  const MapPrescription4 = (checked: boolean) => {
      setTableData4(checked);
      if(checked) { 
        const CLTrail1 = mapRxData(examData, Number(Code.Exam.Map.CLTRAIL)); 
        setPrescription4(CLTrail1);
      } else { setPrescription4({});}
  };

  const MapPrescription5 = (checked: boolean) => {
      setTableData5(checked);
      if(checked) { 
        const CLTrail2 = mapRxData(examData, Number(Code.Exam.Map.CLTRAIL2)); 
        setPrescription5(CLTrail2);
      } else { setPrescription4({});}
  };

  const MapPrescription6 = (checked: boolean) => {
      setTableData6(checked);
      if(checked) { 
        const CLFinal = mapRxData(examData, Number(Code.Exam.Map.CLFINAL)); 
        setPrescription6(CLFinal);
      } else { setPrescription4({});}
  };


  

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={Code.Form.Name.PRESCRIPTION} Privilege={Privilege}  clientData={clientData} fileName='exam' printRef={printRef} showModify={false} setMessage={setMessage} setError={setError}>
          <div className='print-checklist'>
            <div className='print-checklist-options'>
              <span className='print-checklist-title'>Rx Options</span>
              <div><input type='checkbox' checked={tableData1} onChange={(e) => handleCheckChange(e, 1)} title='Final Rx' />Final Rx</div>
              <div><input type='checkbox' checked={tableData2} onChange={(e) => handleCheckChange(e, 2)} title='Final Rx 2' />Final Rx 2</div>
              <div><input type='checkbox' checked={tableData3} onChange={(e) => handleCheckChange(e, 3)} title='Medication' />Medication</div>
              <div><input type='checkbox' checked={tableData4} onChange={(e) => handleCheckChange(e, 4)} title='CL Trial 1' />CL Trial 1</div>
              <div><input type='checkbox' checked={tableData5} onChange={(e) => handleCheckChange(e, 5)} title='CL Trial 2' />CL Trial 2</div>
              <div><input type='checkbox' checked={tableData6} onChange={(e) => handleCheckChange(e, 6)} title='CL Final' />CL Final</div>
            </div>
          </div>
          <div className='print-checklist'>
            <div className='print-checklist-options'>
              <span className='print-checklist-title'>Field Options</span>
              <div><input type='checkbox' checked={fieldClientId} onChange={(e) => handleCheckChange(e, 11)} title='Client ID' />Client ID</div>
              <div><input type='checkbox' checked={fieldAHC} onChange={(e) => handleCheckChange(e, 7)} title='Alberta Health Card' />Health Card</div>
              <div><input type='checkbox' checked={fieldDOB} onChange={(e) => handleCheckChange(e, 8)} title='Date of Birth' />Date of Birth</div>
              <div><input type='checkbox' checked={fieldPhone} onChange={(e) => handleCheckChange(e, 9)} title='Phone' />Phone</div>
              <div><input type='checkbox' checked={fieldAddress} onChange={(e) => handleCheckChange(e, 10)} title='Address' />Address</div>
              <div><input type='checkbox' checked={fieldDispenser} onChange={(e) => handleCheckChange(e, 12)} title='Dispenser' />Dispenser</div>
            </div>
          </div>
        </Button.Print>
        <Control.Print.Data ref={printRef}>
          <Control.Flex>
            <Control.Column size={[0,60,0,0]}>
              <Control.Box>
                <Field.CompanyHead companyId={companyId} locationId={locationId} />
              </Control.Box>
              <Control.Box>
                <Field.Value value={Utility.Get.FullName(clientData, Code.Form.Name.CLIENT).toUpperCase()} valueBold={true} />
                {fieldPhone && <Field.Value value={Utility.Format.Phone(clientData?.client_phone)} />}
                {fieldAddress && <> 
                  <Field.Value value={clientData?.client_address || ''} />
                  <Field.Value value={`${clientData?.city_name || ''} ${clientData?.client_postal || ''}`} /> 
                </>}
              </Control.Box>
            </Control.Column>
            <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
              <Control.Box>
                <Field.SubHead title={Code.Form.Name.PRESCRIPTION} />
                <Control.Form.Barcode value={formData.exam_number!} />       
                <Field.Value title={Title.SNo} value={formData.exam_number} />
                <Field.Value title={Title.Date} value={Utility.Format.DateOnly(formData.exam_date)} />
                <Field.Value title={Title.Doctor} value={Utility.Get.FullName(doctorData,Code.Form.Name.DOCTOR)} />
                {fieldDispenser && <Field.Value title={Title.Dispenser} value={Utility.Get.FullName(userData,Code.Form.Name.USER)} />}
                {fieldClientId && <Field.Value title={Title.ClientId} value={`#${clientData?.client_number}`} />}
                {fieldAHC && <Field.Value title={Title.HealthCard} value={clientData?.client_health_card} />}
                {fieldDOB && <Field.Value title={Title.ClientDOB} value={Utility.Format.DateOnly(clientData?.client_dob)} />}
              </Control.Box>
            </Control.Column>
          </Control.Flex>
          <Control.Box>
              {tableData1 ? (<Control.Html.Prescription prescriptionData={prescription1} classname='pt4 pb4' />) : null } 
              {tableData2 ? (<Control.Html.Prescription prescriptionData={prescription2} classname='pt4 pb4' />) : null } 
              {tableData3 ? (<Control.Html.Medication medicationData={prescription3} classname='pt4 pb4' />) : null } 
              {tableData4 ? (<Control.Html.PrescriptionCL prescriptionCL={prescription4} classname='pt4 pb4' />) : null } 
              {tableData5 ? (<Control.Html.PrescriptionCL prescriptionCL={prescription5} classname='pt4 pb4' />) : null } 
              {tableData6 ? (<Control.Html.PrescriptionCL prescriptionCL={prescription6} classname='pt4 pb4' />) : null } 
          </Control.Box>
          <Control.Flex>
            <Control.Column size={[0,65,0,0]}>
              <>
                <div className='fs14 fwb pt8'>Remarks:</div>
                <div className='fs14 pt2'>* This prescription expires on {Utility.Format.DateOnly(expiryDate)}</div>
              </>
            </Control.Column>
            <Control.Column size={[0,35,0,0]}>
              <Field.DoctorSignature doctorId={formData.doctor_id} />
            </Control.Column>
          </Control.Flex>
          <Field.PrintedOn />
          {/* <div className="page-number" /> */}
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default ExamPrint;